import { Directive, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { parseMonetary } from '../services/price-parser';

/**
 * Applies monetary paste validation and disables accidental scroll-wheel value changes
 * on numeric price inputs. Native `<input type="number">` only guards keystrokes, not
 * paste, so a pasted unicode dash or currency string used to fall straight into
 * `Number(x) || 0` and silently default the price to 0.
 */
@Directive({
  selector: '[appNumericInput]',
  standalone: true
})
export class NumericInputDirective {
  constructor(@Optional() @Self() private ngControl: NgControl) {}

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const pasted = event.clipboardData?.getData('text') ?? '';
    const result = parseMonetary(pasted);

    if (result.error) {
      event.preventDefault();
      this.ngControl?.control?.setValue('');
      this.ngControl?.control?.setErrors({ invalidPrice: result.error });
      this.ngControl?.control?.markAsTouched();
    }
  }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    // Prevent the browser's default "scroll to change value" behavior on a focused
    // number input, which can silently mutate a price while the user is scrolling the page.
    (event.target as HTMLElement)?.blur();
  }
}
